import styled from 'styled-components';

export const HeroSectionStyled = styled.div`
  max-width: 1300px;
  width: 100%;
  margin: 0 auto 100px;
`;

export const Wrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  & .text {
    line-height: 50px;
    max-width: 800px;
    margin-bottom: 20px;
  }

  & .img-boy {
    margin-top: 25px;
  }
  @media (max-width: 1150px) {
    align-items: center;

    & .img-boy {
      margin-top: 0px;
    }
  }
`;

export const HeroLast = styled.div`
  max-width: 1300px;
  display: flex;
  justify-content: space-between;
`;
export const WrapperInitial = styled.div`
  gap: 100px;
  display: flex;
  align-items: center;
`;

export const DiscoverSectionStyled = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  gap: 150px;

  & .discover-us {
    background-color: #f3f9fd;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px;
    height: 250px;
    position: sticky;
    top: 0px;
  }

  & .escape-plan {
    margin-top: 50px;
    max-width: 800px;

    display: flex;
    flex-direction: column;
    gap: 70px;
    margin-bottom: 60px;
  }

  & .first-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 0px;
  }

  & .title {
    font-weight: 600;
    margin-bottom: 20px;
  }
  @media (max-width: 1100px) {
    gap: 0px;
    flex-direction: column;
    & .discover-us {
      width: 100%;
      position: relative;
      margin-bottom: 80px;
    }

    & .escape-plan {
      margin-top: 50px;
      margin: 0 auto;
      max-width: 800px;

      display: flex;
      flex-direction: column;
      gap: 70px;
      margin-bottom: 60px;
    }
    & .title {
      text-align: center;
    }
  }
`;

export const RolesStyled = styled.div`
  display: flex;
  padding: 5px 20px;
  gap: 15px;
`;
export const HeroFirst = styled.div`
  display: flex;
  justify-content: space-between;
`;
